module.exports = __webpack_public_path__ + "static/bigdog-white-9a95425ec11b1a458d2b62ecd3f396cd.png";